/**
 * CMCD `query` transmission mode.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_QUERY = 'query';
